import { addCountryCode, downloadPropertyDocument } from "services";
import { useAsyncAction } from "./useAsyncAction";

interface DownloadDocumentApiPayloadType {
  propertyUuid: string;
  userName: string;
  userEmail?: string;
  userMobile: string;
  singleFileDownload?: boolean;
  fileId?: string | null;
}

export function useDownloadDocumentApi() {
  return useAsyncAction(
    async ({
      propertyUuid,
      userName,
      userEmail,
      userMobile,
      singleFileDownload = false,
      fileId,
    }: DownloadDocumentApiPayloadType) => {
      const payload: any = {
        property_uuid: propertyUuid || "",
        name: userName || "User",
        ...(userEmail?.trim()?.toLowerCase() && {
          email: userEmail?.trim()?.toLowerCase(),
        }),
        mobile: userMobile ? addCountryCode(userMobile) : "NA",
        ...(singleFileDownload && fileId && { property_document_uuid: fileId }),
        share_all: Boolean(fileId) === false,
      };

      await downloadPropertyDocument(payload);
      return true;
    },
  );
}
